
const transformDepositToNotificationData = ({reference, locationFsid, amount, country}) => {
  const url = '/retailer/finances'
  const notificationType = 'payment-deposit-booked'
  const currencySymbol = country === 'ng' ? '₦' : country === 'ke' ? 'KSh' : ''
  const formattedAmount = `${currencySymbol}${amount.toLocaleString()}`
  return {
    notification: {
      title: 'Payment booked successfully',
      body: `Your payment of ${formattedAmount} has been booked successfully.`
    },
    data: {
      type: 'info',
      url,
      action: 'view',
      label: notificationType
    },
    // Unclear if these works, app uses data.url right now
    'webpush': {
      'fcm_options': {
        'link': url,
        'analytics_label': notificationType
      }
    },
    // SL Backend Props:
    locationId: locationFsid,
    event: `deposit:${reference}:booked`
  }
}

module.exports = transformDepositToNotificationData
